module.exports = __webpack_public_path__ + "img/01.21668214.png";